import DATA from './space_garden.json';
import TOUR_DATA from './tour_garden.json';
import UI from './ui_garden.json';


DATA.TOUR_DATA = TOUR_DATA;
DATA.UI = UI;


export default DATA;
